const readMoreElements = document.querySelectorAll('.js--readmore');

const readMore = () => {
  const maxHeight = 280;
  // check element readMoreElements data -attribute (data-heightelement)
  readMoreElements.forEach((element) => {
    const heightElement = element.getAttribute('data-heightelement');
    const readmoreButton = document.querySelector(
      element.getAttribute('data-readmorebutton')
    );
    // get the height of the heightElement
    const height = heightElement
      ? document.querySelector(heightElement).offsetHeight
      : false;
    if (heightElement && height > maxHeight) {
      // add css "has-readmore" class to element
      element.classList.add('has-readmore');
    }

    readmoreButton.addEventListener('click', (e) => {
      // get the height of the clicked element
      const { currentTarget } = e;
      const wrapperElement = document.querySelector(
        currentTarget.getAttribute('data-target')
      );
      const clickHeightElement =
        wrapperElement.getAttribute('data-heightelement');
      // get the height of the heightElement
      const clickHeight = clickHeightElement
        ? document.querySelector(clickHeightElement).offsetHeight
        : false;
      // check if the this element has css class "isopen"
      if (wrapperElement.classList.contains('is-open')) {
        // remove css "open" class from element
        wrapperElement.classList.remove('is-open');
        // replace span inside currentTarget with the text in data-close
        currentTarget.innerHTML = currentTarget.getAttribute('data-closed');
        // remove css style for max-height
        wrapperElement.style.maxHeight = '';
      } else if (clickHeight > maxHeight) {
        // add css "readmore" class to element
        wrapperElement.classList.add('is-open');
        wrapperElement.style.maxHeight = `${clickHeight}px`;
        currentTarget.innerHTML = currentTarget.getAttribute('data-opened');
      }
    });
  });
};

export default readMore;
